/**
 * This constant is hardcoded in CF Worker to replace the placeholder with actual UI returned by /__/cacheable_usp middleware
 * This should be kept in sync with CF Worker for caching to work
 */
export const CACHEABLE_USP_PLACEHOLDER = '###DESKTOP_USP###';
